module.exports = __webpack_public_path__ + "img/bgRB.ec76d607.png";